import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/core/services/auth.service';
import { LoaderService } from 'src/core/services/loader.service';
import { Auth } from 'aws-amplify';
import { AuthenticatorService } from '@aws-amplify/ui-angular';
import { Router } from '@angular/router';
import { getLoginClientMetadata } from 'src/core/services/login-client-metadata';

@Component({
  selector: 'app-portal',
  templateUrl: './portal.component.html',
  styleUrls: ['./portal.component.scss']
})
export class PortalComponent implements OnInit {

  services = {

    handleSignIn: async (formData: Record<string, any>) => {
      let { username, password } = formData;

      this._loaderService.show();
      const clientMetadata = await getLoginClientMetadata();
      return Auth.signIn(username, password, clientMetadata);
    },

    handleConfirmSignIn: async (formData: Record<string, any>) => {
      let { user, code, mfaType } = formData;

      this._loaderService.show();
      return Auth.confirmSignIn(user, code, mfaType);
    },

    handleForgotPassword: async (formData: Record<string, any>) => {
      this._loaderService.hide();
      return Auth.forgotPassword(formData.toString());
    },

    handleForgotPasswordSubmit: async (formData: Record<string, any>) => {
      let { username, code, password } = formData;

      const response: any = await Auth.forgotPasswordSubmit(username, code, password);

      const clientMetadata = await getLoginClientMetadata();
      return Auth.signIn(username, password, clientMetadata);
    }

  };

  constructor(
    private _auth: AuthService,
    private _loaderService: LoaderService,
    public authenticator: AuthenticatorService,
    private _router: Router
  ) { }

  ngOnInit(): void {
  }

}
